/* lua.js generated code 0.3.0 */

AnimationCachePool = xClass("AnimationCachePool")
var _instance = null
AnimationCachePool.getInstance = function () {
    if (!_instance) {
        _instance = AnimationCachePool.new()
        _instance.init()
    }
    return _instance
}
AnimationCachePool.prototype.init = function () {
    var self = this
    self.isReported = true;//是否上报animation数量超限
    self.animationList = {}
    self.inUse = sTable()
    self.frameAnimateCache = {}
    self.flyTailCont = 0
}
AnimationCachePool.prototype.getFrameAnimate = function (key) {
    var self = this
    // body
    var obj = self.frameAnimateCache[key]
    if (obj) {
        // WARN: maybe multi result
        return obj.clone()
    }
}
AnimationCachePool.prototype.addFrameAnimate = function (key, animate) {
    var self = this
    // body
    var obj = self.frameAnimateCache[key]
    if (obj) {
        // obj.release()
        obj.cleanup(true)
        self.frameAnimateCache[key] = null
    }
    animate.retain()
    self.frameAnimateCache[key] = animate
}
AnimationCachePool.prototype.addFlyTailCount = function () {
    var self = this
    self.flyTailCont = self.flyTailCont + 1
}
AnimationCachePool.prototype.decFlyTailCount = function () {
    var self = this
    self.flyTailCont = self.flyTailCont - 1
}
AnimationCachePool.prototype.isFlyTailFull = function () {
    var self = this
    return self.flyTailCont > 15
}
AnimationCachePool.prototype.fill = function (fileName, count, atlasName) {
    let self = this
    if (!self.animationList[fileName]) {
        self.animationList[fileName] = table()
    }
    let max = 50
    let add = Math.min(count, max - $len(self.animationList[fileName]))
    let $limit15 = add
    for (let i = 1; i <= $limit15; i += 1) {
        self.createAnimation(fileName, atlasName)
    }
}
AnimationCachePool.prototype.getAnimation = function (fileName, atlasName) {
    var self = this
    //fileName = fileName.replace(/\.csb$/, '.json')
    //createCSLoaderAnimation中替换
    if (!self.animationList[fileName]) {
        self.animationList[fileName] = sTable()
    }
    if ($len(self.animationList[fileName]) <= 0) {
        self.createAnimation(fileName, atlasName)
    }
    var animation = table.remove(self.animationList[fileName])
    table.insert(self.inUse, animation)
    //
    if(self.isReported && $len(self.inUse) > 250){
        self.isReported = false;
        let level = 1;
        if(window.GameBoardLogic && GameBoardLogic.instance) {
            level = GameBoardLogic.instance.level;
        }
        cc.error("AnimationCachePool inUse Above threshold", $len(self.inUse), level);
        window.logCenter && logCenter.error(new Error(`Current ${$len(self.inUse)} levelId ${level || 1}`), 'AnimationCacheError')
    }
    
    return animation
}
AnimationCachePool.prototype.createAnimation = function (fileName, atlasName) {
    var self = this
    //fileName = fileName.replace(/\.csb$/, '.json')
    //createCSLoaderAnimation中替换
    var str = fileName.split(".")
    if (str.length >= 1 && str[1] === "csb") {
        self.createCSLoaderAnimation(fileName)
    } else if ($len(str) >= 1 && str[1] === "skel" && atlasName !== null) {
        self.createSpineAnimation(fileName, atlasName)
    }
}
AnimationCachePool.prototype.createSpineAnimation = function (fileName, atlasName) {
    let self = this
    let node = sp.SkeletonAnimation.create(fileName, atlasName)
    node.fileName = fileName
    node.retain()
    table.insert(self.animationList[fileName], node)
}
AnimationCachePool.prototype.preload = function (fileName) {
    var self = this
    if (self.animationList[fileName]) {
        return
    } else {
        self.animationList[fileName] = sTable()
        var str = fileName.split(".")
        if (str.length >= 1 && str[1] === "csb") {
            cc.log(`AnimationCachePool preload ${fileName}`)
            self.createCSLoaderAnimation(fileName)
        }
    }
}
AnimationCachePool.prototype.createCSLoaderAnimation = function (fileName) {
    var self = this
	let node = cc.CSLoader.createNode(fileName)
	let actionTimeLine = cc.CSLoader.createTimeline(fileName)
    if (actionTimeLine == null) {
        cc.log("needpreload : failed to load " + fileName);
        return 
    }
    node.actionTimeLine = actionTimeLine
    node.runAction(actionTimeLine)
    node.fileName = fileName
    node.retain()
    table.insert(self.animationList[fileName], node)
}
//noRecycling对于部分需要初始化参数的动画，且不方便重置的。不回收
AnimationCachePool.prototype.backAnimationToPool = function (node, noRecycling = false) {
    var self = this
    if (!node) {
        return 
    }
    
    for (var k = 1, v = self.inUse[1]; v!==undefined&&v!==null; k++, v = self.inUse[k]) {
        if (v === node) {
            table.remove(self.inUse, k)
            if (v.actionTimeLine) {
                // v.actionTimeLine:rewind()
                v.actionTimeLine.pause()
                v.actionTimeLine.clearLastFrameCallFunc()
            }
        }
    }
    if(noRecycling) return;
    assert(node.fileName)
    if (!self.animationList[node.fileName]) {
        self.animationList[node.fileName] = sTable()
    }
    table.insert(self.animationList[node.fileName], node)
}

stopAllactionsInChindren = function  (node)
{
    // node.removeAllChildren();
    node.cleanup(true);
    //node.stopAllActions()
    for (var k in node.children){
        var sub = node.children[k]
        //sub.stopAllActions()
        sub.cleanup(true)
        if (sub.children.length>0)
           stopAllactionsInChindren(sub);
    }
}

AnimationCachePool.prototype.clearCachePool = function () {
    var self = this
    // body
    for (var _file in self.animationList) {
        var list = self.animationList[_file]
        if (list && $len(list) > 0) {
            for (var k = 1, v = list[1]; v!==undefined&&v!==null; k++, v = list[k]) {
                stopAllactionsInChindren(v)
                //v.stopAllActions() 
                v.cleanup(true)
            }
        }
    }
    self.animationList = {}
    for (var k = 1, v = self.inUse[1]; v!==undefined&&v!==null; k++, v = self.inUse[k]) {
        //v.cleanup()
        stopAllactionsInChindren(v)
        v.cleanup(true)
    }
    self.inUse = sTable()
    for (var k in self.frameAnimateCache) {
        var v = self.frameAnimateCache[k]
        // v.stopAllActions()
        v.release()
        // v.cleanup(true)
    }
    self.frameAnimateCache = {}
    self.flyTailCont = 0
}
